import { PageHeader } from "../../components/common/States";
import NotificationSettings from "../../components/notifications/NotificationSettings";
import SessionsCard from "../../components/security/SessionsCard";
import BackupCodesCard from "../../components/security/BackupCodesCard";
import { useAuth } from "../../context/AuthContext";
import { PasswordForm } from "../user/UserProfile";

export default function SecurityPage() {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl space-y-6">
      <PageHeader title="Sécurité du compte" description="Mot de passe, vérification en deux étapes, appareils connectés et notifications." />
      <PasswordForm />
      {user?.platform_role && <BackupCodesCard />}
      <SessionsCard />
      <NotificationSettings />
    </div>
  );
}
